import React from 'react';
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';

import { setGiftCardsOrderDirectDelivery } from '@actions/giftCards';

import { DELIVERY_OPTIONS } from '@common/constants/giftCards';
import { RadioButton } from '@common/components/forms';
import { SIZES } from '@common/components/forms/RadioButton/constants';

import { DeliveryInputsWrapper } from './DeliveryOptions.styled';

const DeliveryOptions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    values: { directDelivery },
    handleChange,
  } = useFormikContext();

  const handleChangeWithSave = event => {
    const {
      target: { value },
    } = event;

    let correctValue;

    if (value === DELIVERY_OPTIONS.TO_MY_HOME.toString()) {
      correctValue = DELIVERY_OPTIONS.TO_MY_HOME;
    } else if (value === DELIVERY_OPTIONS.TO_THE_RECIPIENT.toString()) {
      correctValue = DELIVERY_OPTIONS.TO_THE_RECIPIENT;
    } else {
      return;
    }

    dispatch(setGiftCardsOrderDirectDelivery(correctValue));

    handleChange(event);
  };

  return (
    <DeliveryInputsWrapper>
      <RadioButton
        name="directDelivery"
        checked={directDelivery === DELIVERY_OPTIONS.TO_MY_HOME}
        onChange={handleChangeWithSave}
        value={DELIVERY_OPTIONS.TO_MY_HOME}
        text={t('giftCards.order.delivery.optionSelf', 'Zu mir nach Hause')}
        size={SIZES.LARGE}
      />
      <RadioButton
        name="directDelivery"
        onChange={handleChangeWithSave}
        checked={directDelivery === DELIVERY_OPTIONS.TO_THE_RECIPIENT}
        value={DELIVERY_OPTIONS.TO_THE_RECIPIENT}
        text={t(
          'giftCards.order.delivery.optionReciver',
          'Direkt zur Empfängerin',
        )}
        size={SIZES.LARGE}
      />
    </DeliveryInputsWrapper>
  );
};

export default DeliveryOptions;
